"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _fluxActions = require("flux-actions");

var _ActionTypes = _interopRequireDefault(require("../constants/ActionTypes"));

var _PropertyTypes = _interopRequireDefault(require("../constants/PropertyTypes"));

var _createInitialState = _interopRequireDefault(require("./createInitialState"));

var _createResetChangesForStagedObjectActionType = _interopRequireDefault(require("../actions/createResetChangesForStagedObjectActionType"));

var _createActionHandlerForProperty = _interopRequireDefault(require("./createActionHandlerForProperty"));

var _createActionHandlersForOrderedMapProperty = _interopRequireDefault(require("./createActionHandlersForOrderedMapProperty"));

var _default = function _default(_ref) {
  var _properties$reduce;

  var _ref$namespace = _ref.namespace,
      namespace = _ref$namespace === void 0 ? "" : _ref$namespace,
      objectType = _ref.objectType,
      properties = _ref.properties,
      actionTypes = _ref.actionTypes;
  return (0, _fluxActions.handleActions)(properties.reduce(function (acc, property) {
    if (typeof property === "string") {
      return Object.assign(acc, (0, _createActionHandlerForProperty.default)({
        actionTypes: actionTypes,
        property: property
      }));
    } else if ((0, _typeof2.default)(property) === "object" && property.type) {
      if (property.type === _PropertyTypes.default.SIMPLE) {
        return Object.assign(acc, (0, _createActionHandlerForProperty.default)({
          actionTypes: actionTypes,
          property: property.key
        }));
      } else if (property.type === _PropertyTypes.default.ORDERED_MAP) {
        return Object.assign(acc, (0, _createActionHandlersForOrderedMapProperty.default)({
          actionTypes: actionTypes,
          property: property.key
        }));
      }
    }
  }, (_properties$reduce = {}, (0, _defineProperty2.default)(_properties$reduce, (0, _createResetChangesForStagedObjectActionType.default)({
    namespace: namespace,
    objectType: objectType
  }), function (state, action) {
    return (0, _createInitialState.default)(properties);
  }), (0, _defineProperty2.default)(_properties$reduce, _ActionTypes.default.RESET_ALL_CHANGES, function (state, action) {
    return (0, _createInitialState.default)(properties);
  }), _properties$reduce)), (0, _createInitialState.default)(properties));
};

exports.default = _default;
module.exports = exports.default;